import React, { FC } from 'react'
import { Spacing } from 'Pages/landings/newLandings/common/style'
import { LayoutComponent } from 'Pages/landings/newLandings/common/Layout'
import { BannerComponent } from 'Pages/landings/newLandings/products/rboPage/Banner'
import { AdvantagesComponent } from 'Pages/landings/newLandings/products/rboPage/Advantages'
import { ForOutletComponent } from 'Pages/landings/newLandings/products/rboPage/ForOutlet'
import { FormComponent } from 'Pages/landings/newLandings/products/rboPage/Form'
import { CookieHandlingNotice } from 'Pages/landings/newLandings/common/components'

export const RboPage: FC = () => (
	<LayoutComponent title="Зарегистрируйте бизнес и откройте счет в Сбере за 0 ₽" menuButton="form">
		<Spacing height="24px" heightMS="32px" />
		<BannerComponent />
		<Spacing height="64px" heightLX="80px" />
		<AdvantagesComponent />
		<Spacing height="64px" heightMS="88px" heightLX="104px" />
		<ForOutletComponent />
		<Spacing height="64px" heightMS="88px" heightLX="104px" />
		<FormComponent className="ym-hide-content" />
		<CookieHandlingNotice />
	</LayoutComponent>
)
